import React from "react";
import { useChartsStore } from "~/store/chartStore";
import HourglassLoader from "~/components/HourglassLoader/HourglassLoader";

const WorkspaceLoadingOverlay = () => {
  const progress = useChartsStore((state) => state.workspaceLoadProgress);
  if (!progress) return null;

  return (
    <div style={{ position: "absolute", inset: 0, zIndex: 9999 }}>
      <HourglassLoader
        fullscreen={false}
        label="Carregando desktop"
        progress={{
          current: progress.current,
          total: progress.total,
          detail: progress.symbol,
        }}
      />
    </div>
  );
};

export default React.memo(WorkspaceLoadingOverlay);
